import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import codeServices from './codeServices';

const initialState = {
  // createCouponCode
  codeStateStatus: '',
  codeisError: false,
  codeisSuccess: false,
  codeisLoading: false,
  codeerrorMsg: '',

  // getallDB  coupen
  getAllCodeCoupen: '',
  getCoupenData: [],
  getAllCodeCoupenError: false,
  getAllCodeCoupenSuccess: false,
  getAllCodeCoupenLoading: false,
  getAllCodeCoupenErrMsg: '',

  // deleteDBCoupon
  deleteDbCoupenState: '',
  deleteDbCoupenSuccess: false,
  deleteDbCoupenError: false,
  deleteDbCoupenLoading: false,
  deleteDbCoupenErrMsg: '',
  // delete all
  deleteAllDbCoupenState: '',
  deleteAllDbCoupenSuccess: false,
  deleteAllDbCoupenError: false,
  deleteAllDbCoupenLoading: false,
  deleteAllDbCoupenErrMsg: '',

  // update coupen
  editDbCoupenState: '',
  editDbCoupenSuccess: false,
  editDbCoupenError: false,
  editDbCoupenLoading: false,
  editDbCoupenErrMsg: '',
  // change code status
  statusDbCoupenState: '',
  statusDbCoupenSuccess: false,
  statusDbCoupenError: false,
  statusDbCoupenLoading: false,
  statusDbCoupenErrMsg: '',
};

// create coupen
export const createCouponCode = createAsyncThunk(
  'codes/createCouponCode',

  async (data, thunkAPI) => {
    try {
      return await codeServices.createCouponCode(data);
    } catch (error) {
      const codeerrorMsg =
        (error.response && error.response.data && error.response.data.codeerrorMsg) ||
        error.codeerrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(codeerrorMsg);
    }
  }
);

// get all db coupen
export const getAllDBCoupons = createAsyncThunk('codes/getAllDBCoupons', async (data, thunkAPI) => {
  try {
    return await codeServices.getAllDBCoupons(data);
  } catch (error) {
    const codeerrorMsg =
      (error.response && error.response.data && error.response.data.codeerrorMsg) ||
      error.codeerrorMsg ||
      error.toString();
    return thunkAPI.rejectWithValue(codeerrorMsg);
  }
});

// edit DBCoupon
export const editDBCoupon = createAsyncThunk('codes/editDBCoupon', async (data, thunkAPI) => {
  try {
    return await codeServices.editDBCoupon(data);
  } catch (error) {
    const errorMsg =
      (error.response && error.response.data && error.response.data.codeerrorMsg) ||
      error.codeerrorMsg ||
      error.toString();
    return thunkAPI.rejectWithValue(errorMsg);
  }
});

// deleteDBCoupon
export const deleteDBCoupon = createAsyncThunk('codes/deleteDBCoupon', async (data, thunkAPI) => {
  try {
    return await codeServices.deleteDBCoupon(data);
  } catch (error) {
    const codeerrorMsg =
      (error.response && error.response.data && error.response.data.codeerrorMsg) ||
      error.codeerrorMsg ||
      error.toString();
    return thunkAPI.rejectWithValue(codeerrorMsg);
  }
});

// delete add coupen
export const deleteAllDBCoupon = createAsyncThunk('deleteCodes/deleteAllDBCoupon', async (data, thunkAPI) => {
  try {
    return await codeServices.deleteAllDBCoupon(data);
  } catch (error) {
    const codeerrorMsg =
      (error.response && error.response.data && error.response.data.codeerrorMsg) ||
      error.codeerrorMsg ||
      error.toString();
    return thunkAPI.rejectWithValue(codeerrorMsg);
  }
});

// change status coupen
export const changeStatusCoupen = createAsyncThunk('codes/changeStatusCoupen', async (data, thunkAPI) => {
  try {
    return await codeServices.changeStatusCoupen(data);
  } catch (error) {
    const codeerrorMsg =
      (error.response && error.response.data && error.response.data.codeerrorMsg) ||
      error.codeerrorMsg ||
      error.toString();
    return thunkAPI.rejectWithValue(codeerrorMsg);
  }
});

export const couponSlice = createSlice({
  name: 'codes',
  initialState,
  reducers: {
    resetCode: (state) => {
      state.codeisLoading = false;
      state.codeisSuccess = false;
      state.codeisError = false;
      state.codeerrorMsg = '';
      //   state.codeStateStatus=''
      // getALl db coupnen
      state.getAllCodeCoupenLoading = false;
      state.getAllCodeCoupenSuccess = false;
      state.getAllCodeCoupenError = false;
      state.getAllCodeCoupenErrMsg = '';

      // deleteDbCoupn
      state.deleteDbCoupenLoading = false;
      state.deleteDbCoupenSuccess = false;
      state.deleteDbCoupenError = false;
      state.deleteDbCoupenErrMsg = '';

      // delete all
      state.deleteAllDbCoupenLoading = false;
      state.deleteAllDbCoupenSuccess = false;
      state.deleteAllDbCoupenError = false;
      state.deleteAllDbCoupenErrMsg = '';
      // edit coupen
      state.editDbCoupenLoading = false;
      state.editDbCoupenSuccess = false;
      state.editDbCoupenError = false;
      state.editDbCoupenErrMsg = '';
      // code status
      state.statusDbCoupenLoading = false;
      state.statusDbCoupenSuccess = false;
      state.statusDbCoupenError = false;
      state.statusDbCoupenErrMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCouponCode.pending, (state) => {
        state.codeisLoading = true;
      })
      .addCase(createCouponCode.fulfilled, (state, action) => {
        state.codeisLoading = false;
        state.codeisSuccess = true;
        state.codeStateStatus = action.payload;
      })
      .addCase(createCouponCode.rejected, (state, action) => {
        state.codeisLoading = false;
        state.codeisError = true;
        state.codeerrorMsg = action.payload;
      })

      // getAll coupen db
      .addCase(getAllDBCoupons.pending, (state) => {
        state.getAllCodeCoupenLoading = true;
      })
      .addCase(getAllDBCoupons.fulfilled, (state, action) => {
        state.getAllCodeCoupenLoading = false;
        state.getAllCodeCoupenSuccess = true;
        state.getAllCodeCoupen = action.payload;
        state.getCoupenData = action.payload.getAllDBCoupons;
      })
      .addCase(getAllDBCoupons.rejected, (state, action) => {
        state.getAllCodeCoupenLoading = false;
        state.getAllCodeCoupenError = true;
        state.getAllCodeCoupenErrMsg = action.payload;
      })
      // deleteDBCoupon
      .addCase(deleteDBCoupon.pending, (state) => {
        state.deleteDbCoupenLoading = true;
      })
      .addCase(deleteDBCoupon.fulfilled, (state, action) => {
        state.deleteDbCoupenLoading = false;
        state.deleteDbCoupenSuccess = true;
        state.deleteDbCoupenState = action.payload;
      })
      .addCase(deleteDBCoupon.rejected, (state, action) => {
        state.deleteDbCoupenLoading = false;
        state.deleteDbCoupenError = true;
        state.deleteDbCoupenErrMsg = action.payload;
      })

      // delete All
      .addCase(deleteAllDBCoupon.pending, (state) => {
        state.deleteAllDbCoupenLoading = true;
      })
      .addCase(deleteAllDBCoupon.fulfilled, (state, action) => {
        state.deleteAllDbCoupenLoading = false;
        state.deleteAllDbCoupenSuccess = true;
        state.deleteAllDbCoupenState = action.payload;
      })
      .addCase(deleteAllDBCoupon.rejected, (state, action) => {
        state.deleteAllDbCoupenLoading = false;
        state.deleteAllDbCoupenError = true;
        state.deleteAllDbCoupenErrMsg = action.payload;
      })

      // edit coupen
      .addCase(editDBCoupon.pending, (state) => {
        state.editDbCoupenLoading = true;
      })
      .addCase(editDBCoupon.fulfilled, (state, action) => {
        state.editDbCoupenLoading = false;
        state.editDbCoupenSuccess = true;
        state.editDbCoupenState = action.payload;
      })
      .addCase(editDBCoupon.rejected, (state, action) => {
        state.editDbCoupenLoading = false;
        state.editDbCoupenError = true;
        state.editDbCoupenErrMsg = action.payload;
      })
      // change status
      .addCase(changeStatusCoupen.pending, (state) => {
        state.statusDbCoupenLoading = true;
      })
      .addCase(changeStatusCoupen.fulfilled, (state, action) => {
        state.statusDbCoupenLoading = false;
        state.statusDbCoupenSuccess = true;
        state.changeStatusCoupen = action.payload;
      })
      .addCase(changeStatusCoupen.rejected, (state, action) => {
        state.statusDbCoupenLoading = false;
        state.statusDbCoupenError = true;
        state.statusDbCoupenErrMsg = action.payload;
      });
  },
});

export const { resetCode } = couponSlice.actions;
export default couponSlice.reducer;
